<template>
  <PopoverPanel
    class="absolute left-1/2 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 px-4"
  >
    <div
      :class="[maxWidth]"
      class="w-screen flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5"
    >
      <div v-if="type === 'simple'">
        <div
          class="p-4 text-sm font-semibold leading-6 text-gray-900 shadow-lg ring-1 ring-gray-900/5"
        >
          <Link
            v-for="item in props.items"
            :key="item.name"
            :href="item.href"
            class="block p-2 hover:text-indigo-600"
            prefetch
            >{{ item.name }}</Link
          >
        </div>
      </div>
      <div v-else class="p-4">
        <div
          v-for="item in props.items"
          :key="item.name"
          class="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50"
        >
          <div
            v-if="item.icon"
            class="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
          >
            <component
              :is="item.icon"
              class="h-6 w-6 text-gray-600 group-hover:text-indigo-600"
              aria-hidden="true"
            />
          </div>
          <div>
            <Link
              :href="item.href"
              class="font-semibold text-gray-900"
              prefetch
            >
              {{ item.name }}
              <span class="absolute inset-0" />
            </Link>
            <p v-if="item.description" class="mt-1 text-gray-600">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="props.callsToActions?.length"
        class="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50"
      >
        <Link
          v-for="item in props.callsToActions"
          :key="item.name"
          :href="item.href"
          class="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100"
          prefetch
        >
          <component
            :is="item.icon"
            class="h-5 w-5 flex-none text-gray-400"
            aria-hidden="true"
          />
          {{ item.name }}
        </Link>
      </div>
    </div>
  </PopoverPanel>
</template>

<script setup>
import Link from '@/Common/util/inertia/Link.vue'
import { PopoverPanel } from '@headlessui/vue'
import { computed } from 'vue'

const props = defineProps({
  items: Array,
  callsToActions: Array,
})

const type = computed(() =>
  props.items.some((item) => item.icon)
    ? 'icons'
    : props.items.some((item) => item.description)
    ? 'descriptions'
    : 'simple'
)

const maxWidth = computed(() => {
  return {
    icons: 'max-w-md',
    descriptions: 'max-w-sm',
    simple: 'max-w-56',
  }[type.value]
})
</script>
